import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../shared/services/account.service';
import { getUsersSelector, getUsersStatsSelector } from '../users.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'cc-user-new-invite',
  templateUrl: './user-new-invite.component.html',
  styleUrls: ['./user-new-invite.component.scss']
})
export class UserNewInviteComponent implements OnInit {
  public accountStats;
  public userStats;
  public userList;
  public id;
  public state;

  constructor(private accountService: AccountService, private store: Store<IState>, private route: ActivatedRoute) {}

  ngOnInit() {
    this.store.select(getUsersSelector).subscribe(userList => (this.userList = userList));
    this.accountService.getAccountStats().subscribe(accountStats => (this.accountStats = accountStats));
    this.id = this.route.snapshot.paramMap.get('id');
    this.state = this.route.parent.snapshot.paramMap.get('state');
    this.store.select(getUsersStatsSelector).subscribe(userStats => (this.userStats = userStats));
  }
}
